<template>
    <button 
    :class="classes"
    @click.prevent="$emit('clicked')"
    @mouseover="mouseover"
    @mouseout="mouseout"
    @mouseup="mouseout"
    >
        {{ caption }}
    </button>
</template>

<script>
export default {
  name: "NavButton",
  props: {
    caption: {
      type: String,
      required: true
    },
  },
  computed: {
    classes: function() {
      let result = "quiz__nav__button";
      return result;
    }
  },
  methods: {
    mouseover: function(e) {
      e && e.currentTarget.classList.add("hover");
    },
    mouseout: function(e) {
      e && e.currentTarget.classList.remove("hover");
    }
  }
};
</script>